/** Zeit als HH:MM (lokal) aus ISO-String. */
export function hhmm(iso: string | null | undefined): string {
  if (!iso) return '--:--';
  const d = new Date(iso);
  return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

/** Datum + Zeit kompakt. */
export function dateTime(iso: string | null | undefined): string {
  if (!iso) return '';
  return new Date(iso).toLocaleString([], {
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/** Minuten als "X Std Y Min" bzw. "Y Min". */
export function humanDuration(totalMin: number | null | undefined): { h: number; m: number } {
  const t = Math.max(0, Math.round(totalMin ?? 0));
  return { h: Math.floor(t / 60), m: t % 60 };
}
